import {
  root
} from './01.constant.mjs';

/*==============================================================*/

/**
 * debug
 */
export const debug = console.log.bind(console);
// export const debug = function() {
//   return Function.prototype.bind.call(console.log, console);
// }();

/**
 * debounce | throttle
 * - debounce : 지정된 시간 동안 이벤트가 다시 발생하지 않으면 콜백 (예: 입력 중 검색)
 * - throttle : 지정된 시간 간격으로 콜백을 최대 한 번만 실행 (예: 스크롤 이벤트)
 */
export const debounce = (callback, wait = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => callback.apply(this, args), wait);
  };
};
export const throttle = (callback, interval = 300) => {
  let timer = null;
  return (...args) => {
    if ( timer ) return;
    timer = setTimeout(() => {
      callback.apply(this, args);
      timer = null;
    }, interval);
  };
};

/**
 * check types
 * ? isObject() : 빈 객체도 객체로 판단 - 빈 객체 제외 원할 경우 아래 코드 추가
 * ? - && Object.keys(set).length > 0
 */
export const isRegex = (value) => value instanceof RegExp;
export const isjQuery = (value) => value instanceof jQuery;
export const isBoolean = (value) => typeof value === 'boolean';
export const isFunction = (value) => typeof value === 'function';
export const isObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);
export const isCssSize = (value) => typeof value === 'string' && /^\d+(\.\d+)?(px|%|em|rem|vw|vh)$|^auto$/i.test(value.trim());
export const isNaturalNumber = (value, doAllowString = false) => {
  const num = doAllowString ? Number(value) : value;
  return Number.isInteger(num) && num >= 1;
};
export const isNonNegativeInteger = (value, doAllowString = false) => {
  const num = doAllowString ? Number(value) : value;
  return Number.isInteger(num) && num >= 0;
};

/**
 * is the device dark mode
 */
export const isDeviceDarkmode = () => window.matchMedia?.('(prefers-color-scheme: dark)').matches;

/**
 * 사용자의 마지막 입력 방식을 감지하여 data-modality 속성을 html 요소에 추가
 */
export const setModality = () => {
  let modality = 'mouse'; // 기본값을 mouse로 설정
  root.setAttribute('data-modality', modality);

  window.addEventListener('keydown', (event) => {
    if ( ['Alt', 'Shift', 'Control', 'Meta'].includes(event.key) ) return;
    if ( modality === 'keyboard' ) return;

    modality = 'keyboard';
    root.setAttribute('data-modality', modality);
  }, true);

  ['mousedown', 'pointerdown', 'touchstart'].forEach( ( eventName ) => {
    window.addEventListener(eventName, () => {
      if ( modality === 'mouse' ) return;

      modality = 'mouse';
      root.setAttribute('data-modality', modality);
    }, true);
  });
};

/**
 * custom scroll events: scrollup|down|(up|down)stop
 * [!] 이 함수는 debounce|throttle() 함수와 함께 사용할 것
 * * requestAnimationFrame : 브라우저 렌더링 준비됐을 때만 코드 실행 (성능 대폭 개선)
 */
export const setCustomScrollEvent = () => {
  let lastY = window.scrollY;
  let ticking = false;
  let scrollTimer = null;

  const onScroll = () => {
    const currentY = window.scrollY;
    const direction = currentY > lastY ? 'down' : 'up';

    if ( currentY !== lastY ) {
      window.dispatchEvent(new CustomEvent(`scroll${direction}`));
    }

    lastY = currentY;

    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      window.dispatchEvent(new CustomEvent('scrollstop'));
    }, 300);

    ticking = false; // 작업이 끝났으므로 false 변경 다음 프레임 예약을 허용
  };

  window.addEventListener('scroll', () => {
    if ( !ticking ) window.requestAnimationFrame(onScroll);
    ticking = true; // 호출 직후 true 변경 중복 호출 막음
  }, { passive: true });
};